export default __webpack_public_path__ + "static/media/icaMumbai.b5f9e8f1.png";